export const StorageUpdatedEvent = "storage_updated";
export const SettingsUpdatedEvent = "settings_updated";
